import Select from "react-select";
import React from "react";

const CustomDropdown = ({
  label,
  items,
  value,
  onSelect,
  searchPlaceholder = "Search...",
  showId = false,
  required = false,
}) => {
  const options = items.map((item) => ({
    value: item.id,
    label: showId ? `${item.name} (${item.email})` : item.name,
  }));

  const selectedValue = options.find((option) => option.value === value);

  return (
    <div>
      <label className="form-label">
        {label}
        {required && <span className="text-danger"> *</span>}
      </label>
      <Select
        value={selectedValue}
        options={options}
        onChange={(selectedOption) => onSelect(selectedOption.value)}
        placeholder={searchPlaceholder}
        isSearchable={true}
        classNamePrefix="react-select"
        styles={{
          control: (base) => ({
            ...base,
            borderColor: "#ced4da",
            "&:hover": { borderColor: "#2684FF" },
            boxShadow: "none",
          }),
        }}
      />
    </div>
  );
};

export default CustomDropdown;
